<template>
    <div class="sim-controls">
        <a v-if="simulationState != 'play'"
            :title="translate('Page1.text11')"
            @click="simStart"
            href="#">
            <span class="glyphicon glyphicon-play"></span>
        </a>
        <a v-else
            :title="translate('Page1.text12')"
            @click="simPause"
            href="#">
            <span class="glyphicon glyphicon-pause"></span>
        </a>
    </div>
</template>

<script>
    export default {
        name: "simControls",

        methods: {
            loadSimulations(){
                this.$emit('changed', true);
            },
            async simStart() {
                try {
                    await this.$store.dispatch('callApi', {
                        name: 'start',
                        payload: {simId: this.simId}
                    });
                    this.loadSimulations();
                    this.$emit("isPaused", false);
                } catch (e) {
                    this.$eventHub.$emit('openMessageController', 'error' , e);
                }
            },
            async simPause() {
                try {
                    await this.$store.dispatch('callApi', {
                        name: 'pause',
                        payload: {simId: this.simId}
                    });
                    this.loadSimulations();
                    this.$emit("isPaused", true);
                } catch (e) {
                    this.$eventHub.$emit('openMessageController', 'error' , e);
                }
            },
            
        },
        computed: {
            simId() {
                return this.$store.state.simulation.properties.simId;
            },
            simulationState() {
                return this.$store.state.simulation.properties.state;
            }
        },
    }
</script>

<style scoped>
    .sim-controls {

    }
</style>